import { AgentPurchaseState } from '@bd/agent/types'

export const state: AgentPurchaseState = {
  purchaseOffer: undefined,
  purchaseMessage: undefined,
  error: undefined,
}
